import { defineStore } from 'pinia'
import { PAGE_PARAMS, PAGINATION_PARAMS } from '../pages'
import http from '../helpers/http-call'
import {
  ENDPOINT_URL,
  getDataLang,
  getQuery,
} from '../helpers/api'
import { useAuthStore } from '../auth'

interface IQueryProps {
  showData?: boolean
  category?: string
  headers?: {
    Authorization?: string
  }
  hotel_id?: number
  lang_id?: number
  page_size?: number
  page?: number
}
export interface IOffersCategory {
  name: string
  code: string
  status: string
}
export interface IOffersData {
  offers: Array<IOffers>
  pagination: {
    page: number
    page_size: number
    total_page: number
    total_data: number
  }
}
export interface IOffers {
  offers_title: string
  offers_preview: string
  offers_link: string
  category: string
  promo_code: string
  offers_desc: string
  offers_image: string
}

export interface IOffersState {
  list: IOffersData
  data: IOffersData
  categories: IOffersCategory[]
  events: IOffersData
  scope: string | null | undefined
  home: IOffersData
  additional: IOffersData
  loading: boolean
  params: IQueryProps
}

const PARAMS = {
  ...PAGE_PARAMS,
  category: '',
}

const DATA = {
  offers: [],
  pagination: {
    ...PAGINATION_PARAMS,
  },
}

export const useOffersStore = defineStore('offers', {
  state: (): IOffersState => ({
    list: DATA,
    loading: false,
    data: DATA,
    events: DATA,
    home: DATA,
    scope: 'home',
    additional: DATA,
    categories: [],
    params: PARAMS,
  }),
  getters: {
    getData(): IOffersData {
      const params: IQueryProps = getQuery()
      return getDataLang(this.data, 0, 'offers')
    },
    getHomeData(): IOffersData {
      const params: IQueryProps = getQuery()
      return getDataLang(this.home, 0, 'offers')
    },
    getList(): IOffersData {
      const params: IQueryProps = getQuery()
      return getDataLang(this.list, 0, 'offers')
    },
  },
  actions: {
    setList(data: IOffersData, isData?: boolean) {
      const params: IQueryProps = getQuery()
      this.list = getDataLang(data, 0, 'offers')
      if (isData) {
        this.data = getDataLang(data, 0, 'offers')
        this.home = getDataLang(data, 0, 'offers')
      }
    },
    setCategories(data: IOffersCategory[]) {
      let tmp: IOffersCategory[] = data
      if (data && data.length && data.findIndex(el => el.code === '' && el.status === 'ACTIVE') === -1) {
        tmp.unshift({
          name: 'All',
          code: '',
          status: 'ACTIVE',
        })
      }
      else {
        tmp = []
      }
      this.categories = tmp
    },
    async setAdditional(query: IQueryProps) {
      const {
        showData,
        category,
        page_size,
        page,
        headers,
      }: IQueryProps = query
      const params: IQueryProps = getQuery()
      if (category) {
        Object.assign(params, {
          category,
        })
      }
      if (page_size) {
        Object.assign(params, {
          page_size,
        })
      }
      if (page) {
        Object.assign(params, {
          page,
        })
      }
      if (params?.lang_id)
        delete params.lang_id

      let data = DATA
      let response: any = {
        data: {},
      }
      response = await http.call({
        url: `${ENDPOINT_URL}/offers`,
        headers,
        params: {
          ...params,
          show_category: true,
        },
        method: 'GET',
        data: null,
      })
      if (response?.data?.data)
        data = getDataLang(response.data.data, 0, 'offers')

      this.additional = data

      if (showData)
        return await data
    },
    async setValueData(response: IOffersData) {
      this.data = response
    },
    async setData(query: IQueryProps, scope: string | null | undefined = null) {
      const {
        showData,
        category,
        page_size,
        isScroll,
        page,
        headers,
      }: IQueryProps = query
      const params: IQueryProps = getQuery()
      if (category) {
        Object.assign(params, {
          category,
        })
      }
      if (page_size) {
        Object.assign(params, {
          page_size,
        })
      }
      if (page) {
        Object.assign(params, {
          page,
        })
      }
      // if (params?.lang_id)
      //   delete params.lang_id

      let data = DATA
      let response: any = {
        data: {},
      }
      if (!this.loading) {
        this.loading = true
        response = await http.call({
          url: `${ENDPOINT_URL}/offers`,
          headers,
          params: {
            ...params,
            show_category: true,
          },
          method: 'GET',
          data: null,
        })
      }
      this.params = params
      const useAuth = useAuthStore()
      if (response?.response?.data?.errorCode === 401) {
        const auth = await useAuth?.setData({ showData: true })
        if (auth?.token) {
          response = await http.call({
            url: `${ENDPOINT_URL}/offers`,
            headers: {
              Authorization: `Bearer ${auth.token}`,
            },
            params: {
              ...params,
              show_category: true,
            },
            method: 'GET',
            data: null,
          })
        }
      }
      if (response?.data?.data)
        data = getDataLang(response.data.data, 0, 'offers')
      if (response?.data?.data?.categories && Array.isArray(response?.data?.data?.categories))
        this.setCategories(response.data.data.categories)

      if (isScroll) {
        data = {
          offers: [...this.data.offers, ...data.offers],
          pagination: data.pagination,
        }
      }

      if (scope && Object.keys(this).findIndex((el: string) => el === scope) > -1)
        this[scope] = data
      else
        this.data = data

      setTimeout(() => {
        this.loading = false
      }, 1000)
      if (showData)
        return await data
    },
  },
})
